import { Component, OnInit } from '@angular/core'
import { ApiService } from '../../../framework/data/api.service';
import { AuthService } from '../../../framework/auth/auth.service';
import { DialogsService } from '../../../framework/components/dialog/dialogs.service'
import { MatDialogRef } from '@angular/material'
import { StatusModel } from '../../models/status.model'

@Component({
  selector: 'app-change-status',
  templateUrl: './change-status.component.html',
  styleUrls: ['./change-status.component.scss']
})
export class ChangeStatusComponent implements OnInit {

  user: StatusModel = new StatusModel();
  firsTime = true;
  typeUser: any;
  typeBus: any;
  checked: boolean;
  urlService = 'unlinkDevice'
 private customerStatus: boolean;
  constructor(
    private api: ApiService,
    private auth: AuthService,
    private dialogs: DialogsService,
    private ref: MatDialogRef<ChangeStatusComponent>,
  ) { }

  ngOnInit() {
    this.auth.authenticate().subscribe(user => {
      this.inicializar(user)
    })
  }

  inicializar(user) {
    console.log('user', user)
   this.user.uId = user.uid;
   this.typeUser = user.currentUser.devices.CUS;
   this.typeBus = user.currentUser.devices.BUS;
   console.log('typeUser', this.typeUser)
   console.log('typeBus', this.typeBus)

   // this.nwUser = user.currentUser.devices.unlinkDevices[0].device

    if ( this.typeUser !== 'unlink' || this.typeBus !== 'unlink' ) {
      this.checked = true
      this.firsTime = false
    }
    if (this.typeUser === 'unlink' || this.typeBus === 'unlink' ) {
      this.checked = false
      this.firsTime = false
    }
  }
  exitRef() {
    this.ref.close()
  }
  mouseClick() {
    this.logout();
  }
  logout() {
    const loading = this.dialogs.loading('#00bd9c')
    this.api['postEncrypted'](this.urlService, {
      body: {
        text: JSON.stringify(
          Object.assign(
            {},
            { uId: this.user.uId }
          )
        )
      }
    },
    {
      body: ['text']
    }).subscribe(
      () => {
        loading.hide()
        this.dialogs.okConfirm('La sesión se cerró exitosamente').then(() => {
          this.checked = true;
          this.ref.close()
        })
      },
      () => {
        loading.hide()
        this.dialogs.error('No se pudo cerrar la session')
        this.ref.close()
      // this.dialogService.showDialog('La session', 'No se pudo cerrar la session')
      })
  }

  clickHere() {
    this.ref.close()
  }

}
